import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CostaBackendApiService } from '@services/costa-backend-api.service';
import { ErrorMessagesService } from '@services/error-messages.service';
import { LoadingService } from '@services/loading.service';

@Component({
  selector: 'cck-booking-modal-confirmation-letter',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
  templateUrl: './booking-modal-confirmation-letter.component.html',
  styleUrls: ['./booking-modal-confirmation-letter.component.scss'],
})
export class BookingModalConfirmationLetterComponent {
  private readonly _loadingService = inject(LoadingService);
  private readonly _costaBackendApiService = inject(CostaBackendApiService);
  private readonly _errorMessageService = inject(ErrorMessagesService);
  private readonly _translateService = inject(TranslateService);
  public readonly _ngbActiveModal = inject(NgbActiveModal);

  contactValueAgent = '';
  contactValueGuest = '';
  versionType: 'GUEST' | 'AGENCY' = 'AGENCY';
  errorMessage: string | null = null;

  handleVersionTypeChange(newValue: 'GUEST' | 'AGENCY') {
    this.versionType = newValue;
    if (this.versionType === 'AGENCY') {
      this.contactValueGuest = '';
    }
  }

  async sendConfirmationLetter() {
    this.errorMessage = null;

    this._loadingService.startLoading('ConfirmationLetterService_sendConfirmationLetter');

    if (this.versionType === 'AGENCY') {
      try {
        await this._costaBackendApiService.sendConfirmationLetter(this.contactValueAgent, 'AGENCY');
      } catch (e) {
        await this._errorMessageService.showErrorAlert(e);
        return;
      }
    }
    else if (this.versionType === 'GUEST') {
      try {
        await this._costaBackendApiService.sendConfirmationLetter(this.contactValueGuest, 'GUEST');
      } catch (e) {
        await this._errorMessageService.showErrorAlert(e)
        return;
      }
    }

    this._loadingService.stopLoading('ConfirmationLetterService_sendConfirmationLetter');
    await this._errorMessageService.showInfo(this._translateService.instant("Booking.label_ConfirmationLetterOK"));
  }

}
